import { useState } from "react";
import { HeadLine } from "../../layouts/headers/HeadLine"
import './Style.css';
import { useLocation, Outlet } from "react-router-dom";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const RoomSericeMain = () => {

    const { btnPrimaryColor } = useSelector((store: any) => (store.ui));

    const location = useLocation();

    const [scollHead2, setScollHead2] = useState({
        top: '173px'
    });

    const handleScroll = (e) => {
        //console.log(e.target.scrollTop);
        if (e === '') {
            if (e.target.scrollTop >= 173) {
             //   setScollHead({ top: (173 - e.target.scrollTop) + 'px' });

                setScollHead2({ top: ((173 - e.target.scrollTop) + 173) + 'px' });
            }
        }
    }

    handleScroll(1);

    const isActiveRoute = (route) => {

        return location.pathname.includes(route);

    }

    return (
        <>
            <div className="w-full absolute z-1 head-hi" style={{ background:btnPrimaryColor}}>
                <HeadLine title='Room Service' backurl="/" />

                <div className='flex justify-between items-center pl-6 pr-6 tab-navigator-h1'>

                    <Link to={'breakfast'} className={'flex flex-col items-center justify-between pb-4 ' + (isActiveRoute('breakfast') && 'is-selected')}>

                        <img src="/assets/img/icons/egg-icon.svg" alt="egg icon" width={'24px'} height={'24px'} />

                        <span className='section-txt-hi text-center p-1'>Desayuno</span>

                    </Link>

                    <Link to={'lunch'} className={'flex flex-col items-center justify-between pb-4 ' + (isActiveRoute('lunch') && 'is-selected')}>
                        <img src="/assets/img/icons/lunch-icon.svg" alt="lunch icon" width={'24px'} height={'24px'} />

                        <span className='section-txt-hi text-center p-1'>Almuerzo y Cena</span>

                    </Link>

                    <Link to={'refill'} className={'flex flex-col items-center justify-between pb-4 ' + (isActiveRoute('refill') && 'is-selected')}>
                        <img src="/assets/img/icons/minibar-icon.svg" alt="mini bar icon" width={'24px'} height={'24px'} />

                        <span className='section-txt-hi text-center p-1'>Refill Mini-Bar</span>

                    </Link>

                    <Link to={'orders'} className={'flex relative flex-col items-center justify-between pb-4 ' + (isActiveRoute('orders') && 'is-selected')}>
                        <img src="/assets/img/icons/orders-icon.svg" alt="mini bar icon" width={'24px'} height={'24px'} />

                        <span className='section-txt-hi text-center p-1'>Tus órdenes</span>

                        <span className="absolute w-4 h-4 rounded-full -top-2 right-2" style={{ backgroundColor: '#FF4747' }}>

                        </span>
                    </Link>
                </div>
            </div>
            <div className='w-full content-hi' style={scollHead2}>
                <Outlet />
            </div>
        </>
    )
}
